// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden_3_pds","text-default":"index_text-default_2gUnS","dropdown":"index_dropdown_I4YSk","avatar":"index_avatar_13N6B"};